export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_09.62c9a087.png";